import * as token from './token';

export {
  token,
};



/** WEBPACK FOOTER **
 ** ./src/helpers/request/config/index.js
 **/